import { filterOptions } from '@/utils/query-base'

export default {
  'region': {
    title: '省',
    type: 'select',
    equation: filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE']),
    dictionary: 'region'
  },
  'city': {
    title: '市',
    type: 'select',
    equation: filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE']),
    dictionary: 'city'
  },
  'zzfld000001': {
    describe: true, // 描述
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型
    equation: filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE']), // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'customer2': {
    title: '老商家编码',
    type: 'dialog', // 弹窗
    equation: filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE']),
    dialog: {
      component: 'ClientSelect', // 弹窗组件名称 （客户 ClientSelect）（产品 ProductSelect）
      title: '老商家选择' // 弹窗标题
    }
  },
  'cust_name2': {
    title: '老商家名称',
    equation: filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE']),
    type: 'input'
  },
  'wlybrand': {
    title: '存货分类',
    type: 'select',
    equation: filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE']),
    dictionary: 'A0019'
  },
  'customer1': {
    title: '新商家编码',
    type: 'dialog',
    equation: filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE']),
    dialog: {
      component: 'ClientSelect',
      title: '新商家编码'
    }
  },
  'cust_name1': {
    title: '新商家名称',
    equation: filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE']),
    type: 'input'
  }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/fieldConfig.js